import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../../Utils/Enums";
import ButtonWithIcon from "../../../Components/Reusable/ButtonWithIcon";
import ConfirmationModal from "../../../Components/modal/ConfirmationModal";
import Image from "../../../Components/Reusable/Image";
import { Link, useNavigate } from "react-router-dom";
import RoutesPath from "../../../Utils/RoutesPath";
import * as Yup from "yup";
import { handleApiErrors, validationRegex } from "../../../Utils/Utils";
import { toast } from "react-toastify";
import generatePaginationFooter from "../../../Components/Reusable/CustomPagination";
import { AuthContext } from "../../../Context/authContext";
import BharatSatService from "../../../Services/BharatSatService";
import CustomDropDown from "../../../Components/Reusable/CustomDropDown";
import ClassService from "../../../Services/ClassService";
import DataProvider from "../../../Utils/DataProvider";
import moment from "moment";

const ViewExam = () => {
  const [data, setData] = useState([]);
  const [searchQuery, setSearchQuery] = useState(null);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [editData, setEditData] = useState({});
  const [deleteId, setDeleteId] = useState("");
  const [generate, setGenerate] = useState("");
  const [showAddModal, setShowAddModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showTicketModal, setShowTicketModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [classes, setClasses] = useState([]);
  const [selectedClassFilter, setSelectedClassFilter] = useState("");
  const [selectedMedium, setSelectedMedium] = useState("");
  const [mediumList, setMediumList] = useState(DataProvider.mediumList);
  const { user } = useContext(AuthContext)

  const navigate = useNavigate();

  const fetchData = async () => {
    try {
      const response = await BharatSatService.getBharatSatExamList(
        offset,
        limit,
        searchQuery || "",
        selectedClassFilter || "",
        selectedMedium || ""
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const ChangeStatus = async (id, status) => {
    try {
      await BharatSatService.updateBharatSatExamStatus(id, status);
      toast.success("BharatSatExam Status Updated successfully");
      var updatedData = data;
      updatedData[
        updatedData.findIndex((item) => item.bharatSatExamId === id)
      ].is_active = status;
      setEditData(updatedData);
      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteSingleExam = async (id) => {
    try {
      await BharatSatService.deleteBharatSatExam([id]);
      toast.success("BharatSatExam Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };


  const deleteMultipleExam = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.bharatSatExamId);
          }
        });
      }
      await BharatSatService.deleteBharatSatExam(itemsToDelete);
      toast.success("BhratSatExam Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);

    } catch (error) {
      handleApiErrors(error);
    }
  };

  const generatehallticketbhratsat = async (bharatSatExamId) => {
    setLoading(true)
    try {
      const response = await BharatSatService.generatehallticketbhratsat([bharatSatExamId]);
      const pdfBlob = new Blob([response], { type: 'application/pdf' });
      const pdfUrl = URL.createObjectURL(pdfBlob);
      const newWindow = window.open(pdfUrl, '_blank');

      // If the window is not null (i.e., it was successfully opened)
      if (newWindow) {
        // Set the title of the new window/tab
        newWindow.document.title = "Hall Ticket";

        // Write the PDF to the new window
        newWindow.document.write(`
              <html>
                  <head>
                      <title>Hall Ticket</title>
                  </head>
                  <body>
                      <embed src="${pdfUrl}" type="application/pdf" width="100%" height="100%">
                  </body>
              </html>
          `);
        newWindow.document.close(); // Finish the document writing

        newWindow.focus(); // Focus the new window/tab
      } else {
        alert("Please allow popups to view your Hall Ticket.");
      }
      toast.success("Your Hall Ticket generated successfully");
      setShowTicketModal(false);
      fetchData();
      setLoading(false)
    } catch (error) {
      console.error("Error generating hall ticket:", error);
    }
  };



  useEffect(() => {
    fetchData();
    getAllClasses()
  }, [offset]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (
        searchQuery != null ||
        selectedClassFilter != null ||
        selectedMedium != null
      ) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery, selectedClassFilter, selectedMedium]);

  const formatTimeTo12Hour = (isoTime) => {
    if (!isoTime) return "";
    // Use Moment.js to parse the ISO time string and format it in 12-hour format with AM/PM
    return moment(isoTime).format('hh:mm A');
  };


  return (
    <div>
      <div className="mb-3 d-flex justify-content-between align-items-center">
        <h1 className="black fs-18 fw-600 mb-0">BHARAT SAT</h1>
        <div className="d-flex">       
          <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
          <h4 className="fs-12 fw-500 primary mb-0">Bharat SAT</h4>
        </div>
      </div>
      <div className="table_container" style={{ display: "block" }}>
        <h1 className="black fs-18 fw-600 mb-0">Bharat SAT Exam List  </h1>

        <div className="table_title">
          <div className="table_headings mt-2 Commonclass">
            <h1 className="black fs-18 fw-600 mb-0" >
              <div
                className="table_delete_icon"
                style={{
                  opacity:
                    data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                  pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                }}
                onClick={() => {
                  const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Bharat Sat Exam"
                  );

                  if (!viewBharaSatExamPreviledge?.delete) {
                    // If the user does not have delete permission, show a toast warning
                    toast.warning("You don't have permission to delete Bharat Sat Exam.");
                    return;
                  }
                  if (!(data.findIndex((item) => item.isChecked) == -1)) {
                    setIsMultipleDelete(true);
                    setShowDeleteModal(true);
                  }
                }}
              >
                <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
              </div>
            </h1>
            <div className="d-flex gap-4 align-items-center Responsivesection justify-content-end">
              <div className="position-relative ">
                <input
                  type="search"
                  className="search_box search_bar"
                  placeholder="Search exam"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                />
                <Image
                  src={SvgImages.search}
                  style={ImageFilters.gray}
                  className="search_icon"
                  alt="Search Icon"
                  height="20px"
                />
              </div>

              <ButtonWithIcon
                text={"Add Exam"}
                icon={SvgImages.plus}
                onClick={() => {
                  const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                    (priv) => priv.parameter === "Bharat Sat Exam"
                  );
                  if (viewBharaSatExamPreviledge?.create) {
                    navigate(RoutesPath.addexam, { state: null });
                  } else {
                    toast.warning("You don't have permission to add a Bharat Sat Exam.")
                  }
                }}
              />
            </div>

          </div>

        </div>
        <div className=" row  align-items-center responsivetablepackagetwo">
          <CustomDropDown
            // labelTitle="Filter By Class"
            placeholder="Class"
            name="class"
            id="class"
            Dropdownclass={"col-xl-3 col-md-12 col-lg-8 col-sm-12 col-12 "}
            labelClass="commissionsection"
            onChange={(e) => {
              setSelectedClassFilter(e.value);
              setOffset(0)
            }}
            options={
              [{ value: "", label: "All" }, ...classes.map((e) => { return { value: e._id, label: e.class_name } }) ?? []]
            }
          />
          <CustomDropDown
            placeholder="Filter By Medium"
            name="medium"
            id="medium"
            Dropdownclass={"col-xl-3 col-md-12 col-lg-8 col-sm-12 col-12 "}
            options={
              [{ value: "", label: "All" }, ...mediumList ?? []]
            }
            labelClass="commissionsection"
            onChange={(e) => {
              setSelectedMedium(e.value);
              setOffset(0);
            }}
          />

        </div>

        <div style={{ overflowX: "auto" }}>
          <table
            className="table mb-0 mt-3"
            id="dtHorizontalExample"
            cellSpacing="0"
            width="100%"
          >
            <thead>
              <tr className="table_heading">
                <th scope="col" style={{ width: "5%" }}>
                  <label className="d-flex align-items-center justify-content-center">
                    <input
                      className="cursor-pointer"
                      type="checkbox"
                      style={{ height: "16px", aspectRatio: 1 }}
                      checked={
                        data?.length > 0 &&
                        data?.findIndex((item) => !item.isChecked) == -1
                      }
                      onChange={(value) => {
                        var updatedData = data;
                        updatedData.map((element) => {
                          element.isChecked = value.target.checked;
                        });
                        setData([...updatedData]);
                      }}
                    />
                    <span className="checkmark"></span>
                  </label>
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Sr No.
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Bharat SAT Exam Name
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Class
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Medium
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Exam Date
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Exam Start Time
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Exam End Time
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Student Batch
                </th>              
                <th scope="col" style={{ width: "5%" }}>
                  Current Status
                </th>
                <th scope="col" style={{ width: "5%" }}>
                  Action
                </th>
              </tr>
            </thead>
            <tbody className="bg_light">
              {data?.map((item, index) => (
                <tr key={index}>
                  <td>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        checked={item.isChecked || false}
                        style={{ height: "16px", aspectRatio: 1 }}
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData[index].isChecked =
                            value.target.checked;
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </td>
                  <td>{limit * offset + (index + 1)}</td>
                  <td title={item.bharatSatExamName}>{item.bharatSatExamName}</td>
                  <td>{item.className}</td>
                  <td>{item.medium}</td>
                  <td>{item.bharatSatExamDate}</td>
                  <td>{formatTimeTo12Hour(item.examStartTime)}</td>
                  <td>{formatTimeTo12Hour(item.examEndTime)}</td>
                  <td >
                    {/* {`${RoutesPath.studentbatchlist}/${item.bharatSatExamId}` */}
                    <Link to={`${RoutesPath.studentbatchlist}/${item.bharatSatExamId}`} className="cursor-pointer anchorlink " >
                      View Batch
                    </Link>
                  </td>                
                  <td>

                    <label
                      className="switch"
                      data-bs-target="#change_status"
                      data-bs-toggle="modal"
                    >
                      <input
                        type="checkbox"
                        checked={item.is_active}
                        onChange={() => {

                          const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Bharat Sat Exam"
                          )
                          if (!viewBharaSatExamPreviledge?.update) {

                            toast.warning("You don't have permission to update the status.");
                            return;
                          }

                          setShowConfirmationModal(true);
                          setStatusChangeData(item);
                        }}
                      />
                      <span className="slider round"></span>
                    </label>
                  </td>
                  <td>
                    <div className="d-flex gap_8">
                      <a
                        onClick={() => {
                          const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Bharat Sat Exam"
                          );

                          if (!viewBharaSatExamPreviledge?.update) {

                            toast.warning("You don't have permission to edit Bharat Sat Exam.");
                            return;
                          }
                          navigate(RoutesPath.editexam, {
                            state: item,
                          })
                        }}
                        className="edit_icons cursor-pointer"
                        data-bs-target="#editclass"
                        data-bs-toggle="modal"
                      >
                        <Image
                          src={SvgImages.edit}
                          style={ImageFilters.green}
                          className="add_icons"
                          alt="Edit Icon"
                        />
                      </a>
                      <a
                        className="delete_icons cursor-pointer"
                        onClick={() => {
                          const viewBharaSatExamPreviledge = user?.setPrivileges?.find(
                            (priv) => priv.parameter === "Bharat Sat Exam"
                          );
                          if (!viewBharaSatExamPreviledge?.delete) {

                            toast.warning("You don't have permission to delete Bharat Sat Exam.");
                            return;
                          }
                          setDeleteId(item.bharatSatExamId);
                          setIsMultipleDelete(false);
                          setShowDeleteModal(true);
                        }}
                      >
                        <Image
                          src={SvgImages.deleteIcon}
                          style={ImageFilters.red}
                          data-bs-target="#delete-modal"
                          data-bs-toggle="modal"
                          alt="Delete Icon"
                        />
                      </a>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

        </div>
        {generatePaginationFooter(
          availableDataCount,
          limit,
          offset,
          setOffset
        )}


      </div>
      {/* Change Class Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(
            getStatusChangeData.bharatSatExamId,
            !getStatusChangeData.is_active
          );
        }}
        theme={ConfirmationModalTheme.warning}
      />

      <ConfirmationModal
        showModal={showTicketModal}
        setShowModal={setShowTicketModal}
        text={"Are you sure want to generate E-hall ticket?"}
        icon={SvgImages.righticonmark} // Specify the path to your delete icon
        rightClickAction={() => {
          generatehallticketbhratsat(generate)
        }}
        theme={ConfirmationModalTheme.success}
        rightButtonBgColor="#3EC13E"
        loading={loading}
      />

      {/* Delete blog category Modal */}

      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected BharatSat exam?"
            : "Are you sure want to delete BharatSat exam?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete ? deleteMultipleExam() : deleteSingleExam(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />
      {/* Add Class Modal */}
    </div>
  );
};

export default ViewExam;
